import React, { useEffect, useState } from 'react';
import API from 'files/api.js';
import Appearance from 'styles/Appearance.js';
import { Layer, Map, Source } from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';

export default ({ features, style }) => {

    const [loaded, setLoaded] = useState(false);
    const [viewState, setViewState] = useState({});

    const onSetRegion = region => {
        console.log(region);
        if(region) {
            setViewState({
                longitude: region.center.long || 0,
                latitude: region.center.lat || 0,
                zoom: region.zoom || 3.5
            });
        }
    }

    const getFeatureCollections = () => {
        if(!features || !features.data || loaded === false) {
            return null;
        }
        let targets = features.layers || [features.layer];
        return (
            <Source
            data={features.data}
            key={features.id}
            id={features.id}
            type={'geojson'}>
                {targets.map(target => (
                    <Layer 
                    key={target.id}
                    {...target} />
                ))}
            </Source>
        )
    }

    useEffect(() => {
        onSetRegion(features?.region);
    }, [features]);

    return (
        <div style={{
            border: `1px solid ${Appearance.colors.divider()}`,
            borderRadius: 10,
            height: 250,
            overflow: 'hidden',
            width: '100%',
            ...style
        }}>
            <Map
            {...viewState}
            attributionControl={true}
            height={'100%'}
            initialViewState={{
                latitude: 40,
                longitude: -100,
                zoom: 3.5
            }}
            mapboxAccessToken={API.mapbox}
            mapStyle={window.theme === 'dark' ? 'mapbox://styles/llifewipe/cmfy9zvzb00dr01pd7uoq02dn' : 'mapbox://styles/llifewipe/cmfy9xlm5002001qtbrdx5kl1'}
            onLoad={setLoaded.bind(this, true)}
            width={'100%'}>
                {getFeatureCollections()}
            </Map>
        </div>
    )
}
